module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-sidebar",
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticClass: "component-padding"
  }, [_c('button', {
    staticClass: "button-type-f text-left",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Export Spreadsheet")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "admin-table"
  }, [_vm._m(1), _vm._v(" "), _vm._l((14), function(n) {
    return _c('tr', [_vm._m(2, true), _vm._v(" "), _c('td', [_vm._v("Phelix Systems")]), _vm._v(" "), _c('td', [_vm._v("6SGHA14")]), _vm._v(" "), _c('td', [_vm._v("140.00")]), _vm._v(" "), _c('td', [_vm._v("PHP")]), _vm._v(" "), _vm._m(3, true)])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "button-type-f text-left",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Export Spreadsheet")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "products-admin-options"
    }
  }, [_c('h1', [_vm._v("Supplier Products")]), _vm._v(" "), _c('div', [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Search Product"
    }
  }), _vm._v(" "), _c('select', {
    attrs: {
      "name": "fabrianne"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All Suppliers")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Phelix Systems")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Fabrianne Inc")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Ast Corps")])]), _vm._v(" "), _c('select', {
    attrs: {
      "name": "francis"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Sort By")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Product Code")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Price")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Company")]), _vm._v(" "), _c('th', [_vm._v("Product Code")]), _vm._v(" "), _c('th', [_vm._v("Price")]), _vm._v(" "), _c('th', [_vm._v("Currency")]), _vm._v(" "), _c('th', [_vm._v("Options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "admin-table-row-image"
  }, [_c('img', {
    attrs: {
      "src": "static/images/j.jpeg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "admin-table-row-options"
  }, [_c('button', [_vm._v("Edit Item")]), _vm._v(" "), _c('button', [_vm._v("Delete Item")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21deda96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminSupplierItems.vue
// module id = 140
// module chunks = 0